module.exports = __webpack_public_path__ + "img/map-marker-icon-approx.3cdf2fc0.png";